module.exports = __webpack_public_path__ + "static/scale-model-of-mast-center-aquarium-in-kent-washington-9fd2d68efbb7544863095f0e818110f7.png";